export default function addDays(date: Date | string, days: number) {
    const ret = new Date(date);
    ret.setDate(ret.getDate() + days);
    return new Date(ret);
}
